// src/constants/routes.js
export const ROUTES = {
  LOGIN: '/login',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password',
  DASHBOARD: '/dashboard',
  PROFILE_EDIT: '/profile/edit',
  NOT_FOUND: '/404',
};
